import Vue from 'vue'

// 401(token 过期/被踢) → 跳 keycloak 登录页。
// keycloak 访问方式与 account.js / permission.js 一致：Vue.prototype.$keycloak。
// isRedirecting 兜并发：多个请求同时 401 只跳一次。
let isRedirecting = false

export default function handleUnauthorized() {
  if (isRedirecting) return
  const kc = Vue.prototype.$keycloak
  // keycloak 未就绪时 createLoginUrl 可能为 null(见 permission.js 等待逻辑)，拿不到就不跳、不报错。
  if (kc && typeof kc.createLoginUrl === 'function') {
    isRedirecting = true
    window.location.replace(kc.createLoginUrl())
  }
}
